module.exports = __webpack_public_path__ + "img/right_def.035da1e1.png";